import { parse, stringify } from "qs"
import { createRoot } from "react-dom/client"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import { invariant } from "./utils"
import { routeTree } from "./routeTree.gen"
import { initSentry } from "@/monitoring"
import "./index.css"

initSentry()

const router = createRouter({
  routeTree,
  parseSearch: (search) =>
    parse(search, {
      ignoreQueryPrefix: true,
      decoder: (str, defaultDecoder, _charset, type) => {
        const decoded = defaultDecoder(str)

        if (type === "value" && /^-?\d+\.?\d*$/.test(decoded)) {
          const num = Number(decoded)

          return isNaN(num) ? decoded : num
        }

        return decoded
      },
    }),
  stringifySearch: (search) =>
    stringify(search, {
      addQueryPrefix: true,
    }),
})

declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router
  }
}

const root = document.getElementById("root")
invariant(root)

createRoot(root).render(<RouterProvider router={router} />)
